import { render, staticRenderFns } from "./leftmenu.vue?vue&type=template&id=30f553f6&scoped=true"
import script from "./leftmenu.vue?vue&type=script&lang=js"
export * from "./leftmenu.vue?vue&type=script&lang=js"
import style0 from "./leftmenu.vue?vue&type=style&index=0&id=30f553f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f553f6",
  null
  
)

export default component.exports